// extracted by mini-css-extract-plugin
export default {"footer":"footer__XCcUp","social":"social__s42WA","logo":"logo__YuE7E"};